import { messageConstants } from '../_constants';

const initialStatus = {
  successAction: false,
  items: [],
  total : 0,
  item: null,
  loading: false,
  error: null,

};

export function messages(state = initialStatus, action) {


  switch (action.type) {
    case messageConstants.KICK_REQUEST:
      return {
        ...state,
        successAction: false,
        doingAction: true,
        actionError: false,
        actionErrorMsg: null,

      };

    case messageConstants.KICK_SUCCESS:
      const key = state.items.findIndex(item => item.id === action.message.id);
      let ii = state.items;

      if (key in ii) {
        ii.splice(key, 1, action.message);
      } else {
        ii.push(action.message);
      }

      return {
        ...state,
        successAction: true,
        doingAction: false,
        actionError: false,
        actionErrorMsg: null,
        items: ii,
      };
      break;

    case messageConstants.KICK_FAILURE:
      return {
        ...state,
        successAction: false,
        doingAction: false,
        actionError: true,
        actionErrorMsg: action.error,
      };

    case messageConstants.GETALL_REQUEST:
      return {
        ...state,
        loading: true
      };
    case messageConstants.GETALL_SUCCESS:
      return {
        ...state,
        items: action.messages,
        total: action.meta.total,
        loading: false
      };
    case messageConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };

    case messageConstants.GETONE_REQUEST:
      return {
        ...state,
        loading: true
      };
    case messageConstants.GETONE_SUCCESS:
      return {
        ...state,
        item: action.message,
        loading: false
      };
    case messageConstants.GETONE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };

    default:
      return state;
  }
}